import { createAction, props } from '@ngrx/store';
import { ExpectedStocks } from '../state/stocks.state';

export const updateStocksAveragePrice = createAction(
  '[Stocks] GET_UPDATE_STOCKS_AVERAGE_PRICE',
  props<{ expectedStocks: ExpectedStocks }>()
);

export const resetStocksAveragePrice = createAction(
  '[Stocks] GET_RESET_STOCKS_AVERAGE_PRICE'
);
